import React from 'react';
import './Footer.css';
import { ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-col footer-about">
            <img 
              src="https://customer-assets.emergentagent.com/job_kyrodigital/artifacts/ewsd5gjt_ChatGPT%20Image%20Jan%2018%2C%202026%2C%2009_44_50%20PM.png" 
              alt="KyroTech Logo" 
              className="footer-logo"
            />
            <p className="footer-description">
              Transforming ideas into digital reality. We create exceptional digital experiences that drive business growth.
            </p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
            </div>
          </div>

          <div className="footer-col">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><a onClick={() => document.getElementById('home').scrollIntoView({ behavior: 'smooth' })}>Home</a></li>
              <li><a onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}>About</a></li>
              <li><a onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}>Services</a></li>
              <li><a onClick={() => document.getElementById('portfolio').scrollIntoView({ behavior: 'smooth' })}>Portfolio</a></li>
              <li><a onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>Contact</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-title">Our Services</h3>
            <ul className="footer-links">
              <li><a>Website Development</a></li>
              <li><a>Mobile App Development</a></li>
              <li><a>UI/UX Design</a></li>
              <li><a>Digital Marketing</a></li>
              <li><a>SEO Services</a></li>
              <li><a>Branding</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h3 className="footer-title">Contact Info</h3>
            <ul className="footer-contact">
              <li>
                <span className="contact-label">Email:</span>
                <a href="mailto:hello@kyrotech.com">hello@kyrotech.in</a>
              </li>
              <li>
                <span className="contact-label">Phone:</span>
                <a href="tel:+91 8140320831">+91 8140320831</a>
              </li>
              <li>
                <span className="contact-label">Hours:</span>
                <span>09:00 AM - 10:30 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © 2025 KyroTech. All rights reserved. | Designed with passion
          </p>
          <button className="back-to-top" onClick={scrollToTop}>
            <ArrowUp size={20} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
